export function debounce(fn, delay) {
    let timer = null;
    let last = null;
    return function(...args){
        let now = Date.now();
        if (now - last < delay) {
            if (timer) return;
            timer = setTimeout(()=>{
                fn.apply(this,args);
                last = now;
                timer = null;
            },delay)
        } else {
            fn.apply(this,args);
            last = now;
        }
    }
}


// WEBPACK FOOTER //
// ./src/utils/debounce.js